import { Minigrid } from "../types/minigridtypes";
import { checkValidity } from "../../../common/utils/inputValidityChecker";

export interface ValidationMingrid {
    isErrorName: boolean,
    isErrorDescription: boolean,
    isErrorLocationLat: boolean,
    isErrorLocationLng: boolean,
    isErrorCapacity: boolean,
    isErrorInverter: boolean,
    isErrorBattery: boolean,
    isErrorPower: boolean,
    isErrorPowerGenerator: boolean
    
}

export const validationInputCreationMinigrid = (minigrid: Minigrid) => {

    let isAllValid = true

    let initialValidation: ValidationMingrid = {
        isErrorName: false,
        isErrorDescription: false,
        isErrorLocationLat: false,
        isErrorLocationLng: false,
        isErrorCapacity: false,
        isErrorInverter: false,
        isErrorBattery: false,
        isErrorPower: false,
        isErrorPowerGenerator: false
    }

    if (!minigrid.minigrid_name) {
        initialValidation.isErrorName = true
        isAllValid = false
    }

    if (!checkValidity(minigrid.minigrid_name, 'text-not-empty')) {
        initialValidation.isErrorName = true
        isAllValid = false
    }

    if (!checkValidity(minigrid.minigrid_location_lat, 'number-float')) {
        initialValidation.isErrorLocationLat = true
        isAllValid = false
    }

    if (!checkValidity(minigrid.minigrid_location_lng, 'number-float')) {
        initialValidation.isErrorLocationLng = true
        isAllValid = false
    }

    if (!checkValidity(minigrid.minigrid_battery_capacity, 'number-float')) {
        initialValidation.isErrorCapacity = true
        isAllValid = false
    }

    if (!checkValidity(minigrid.minigrid_inverter, 'number-float')) {
        initialValidation.isErrorInverter = true
        isAllValid = false
    }

    if(!checkValidity(minigrid.minigrid_battery_capacity, 'number-float')){
        initialValidation.isErrorBattery = true
        isAllValid = false
    }

    if(!checkValidity(minigrid.minigrid_power, 'number-float')){
        initialValidation.isErrorPower = true
        isAllValid = false
    }

    if (!checkValidity(minigrid.minigrid_power_generator, 'number-float')) {
        initialValidation.isErrorPowerGenerator = true
        isAllValid = false
    }

    if (!checkValidity(minigrid.minigrid_description, 'text-not-empty')) {
        initialValidation.isErrorDescription = true
        isAllValid = false
    }


    if (isAllValid) {
        return null
    }

    return initialValidation

}